const Backbone = require('backbone');
const Nunjucks = require('view');
const template = require('./categoria.twig');


const View = Backbone.View.extend({
	tagName: 'li',
	initialize: function() {
		var that = this;		

		that.model.set('opened',false);

		that.listenTo(that.model,'remove', that.remove);
		that.listenTo(that.model,'change:opened', that.toogleSubcategorias);

		that.render();
	},
	toogleSubcategorias: function(e) {
		var that = this;

		if (that.model.get('opened')) {
			that.$el.find('ul:first').css({display:'block'});
		} else {
			that.$el.find('ul:first').css({display:'none'});			
		}
	},
	events: {
		'click a:first': 'setOpened'
	},
	setOpened: function() {
		var that = this;
		var opened = !that.model.get('opened');
		that.model.set('opened',opened);
	},
	render: function() {
		var that = this;
		var data = that.model.toJSON();
		
		var html = Nunjucks.renderString(template,data);

		that.$el.html(html);
	}
});

module.exports = View;


//////////////////
// WEBPACK FOOTER
// ./views/cardapio/categoria.js
// module id = 17
// module chunks = 0